import type { ChartDataPoint } from '../../types/ChartDataPoint';

export type StackLayerExtent = {
  y0: number;
  y1: number;
};

function finiteNumberOrZero(value: ChartDataPoint[string] | undefined): number {
  return typeof value === 'number' && Number.isFinite(value) ? value : 0;
}

/**
 * Stack offsets for each series at a datum.
 *
 * Positive values stack upward from 0; negative values stack downward from 0.
 * These are raw data-space bounds. Remap `y0`/`y1` independently — remapping each
 * layer then adding (as visx AreaStack does) is not equal to remapping the stacked
 * total unless both domains start at 0.
 */
export function getStackLayerExtents(
  datum: ChartDataPoint | undefined,
  series: ReadonlyArray<{ dataKey: string }>,
): StackLayerExtent[] {
  let positiveCumulative = 0;
  let negativeCumulative = 0;

  return series.map((config) => {
    if (!datum) {
      return { y0: 0, y1: 0 };
    }

    const value = finiteNumberOrZero(datum[config.dataKey]);
    if (value >= 0) {
      const y0 = positiveCumulative;
      positiveCumulative += value;
      return { y0, y1: positiveCumulative };
    }

    const y0 = negativeCumulative;
    negativeCumulative += value;
    return { y0, y1: negativeCumulative };
  });
}
